/* eslint-disable no-undef */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
 import reportWebVitals from './reportWebVitals';
import router from "./router.js"
import { RouterProvider } from 'react-router-dom'

ReactDOM.createRoot(document.getElementById('root')).rendermarkerDiv.parentNode.removeChild(markerDiv)(
  <React.StrictMode>
<RouterProvider router={router} />
  </React.StrictMode>,
)


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
